import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import { setSupport, getSupport, setCookie, getCookie } from '@/utils/support';

const whiteList = ['/login', '/license'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login' || to.path === '/license') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          // console.log('res.data',res.data.data)
          // 权限setCookie
          setCookie("is_purchase", res.data.data.is_purchase);
          setCookie("is_sale", res.data.data.is_sale);
          setCookie("is_fico", res.data.data.is_fico);
          setCookie("grouping", res.data.data.grouping);
          setCookie("is_main", res.data.data.is_main);
          setCookie("eChartType", res.data.data.type);
          setCookie("subuser_id", res.data.data.subuser_id);
          setCookie("is_check_cart_all", res.data.data.is_check_cart_all);
          setCookie("company_name", res.data.data.company_name);
          setCookie("salelistfunc", res.data.data.salelistfunc);
          setCookie("partner_id", res.data.data.partner_id);
          setCookie("serveAppletsPopup", res.data.data.popup);


          let menus = res.data.data.menus;
          // let menus=res.data.menus;
          // let username=res.data.username;
          let username = res.data.data.nickname;
          store.dispatch('GenerateRoutes', { menus, username }).then((ress) => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js